<template>
  <v-container>
    <v-card class="py-4 px-3">
      <v-layout column>


        <v-layout wrap>
          <v-btn class="primary" @click="printPDF('admin|petition|petition|petition_create_permanent_council-make-file','make_file','application/pdf','council')"
                 v-if="allowed('admin|petition|petition|petition_create_permanent_council-make-file', 'make_file')" :loading=generatePdf.council>
            Ходатайство о создании PDF
          </v-btn>
          <v-btn class="primary" @click="printPDF('admin|petition|petition|petition_create_permanent_council|candidate-make-file','make_file','application/pdf','candidate')"
                 v-if="allowed('admin|petition|petition|petition_create_permanent_council|candidate-make-file', 'make_file')" :loading=generatePdf.candidate>Сформировать
            PDF списка кандидатов
          </v-btn>
          <v-btn class="primary" @click="printPDF('admin|petition|petition|petition_create_permanent_council-make-candidates-csv','make_candidates_csv','application/csv','candidates')"
                 v-if="allowed('admin|petition|petition|petition_create_permanent_council-make-candidates-csv', 'make_candidates_csv')" :loading=generatePdf.candidate>Сформировать
            CSV списка кандидатов
          </v-btn>

          <v-btn class="primary"
                 @click="printPDF('admin|petition|petition|petition_create_permanent_council|candidate-make-personals-file', 'make_personals_file','application/pdf','personals')"
                 v-if="allowed('admin|petition|petition|petition_create_permanent_council|candidate-make-personals-file', 'make_personals_file')" :loading=generatePdf.personals>Сформировать PDF каждого кандадата
          </v-btn>

          <v-btn class="primary" @click="printPDF('admin|petition|petition|petition_create_permanent_council|department-make-file','make_file','application/pdf','department')"
                 v-if="allowed('admin|petition|petition|petition_create_permanent_council|department-make-file', 'make_file')" :loading=generatePdf.department>Сведения о
            научной эффективности PDF
          </v-btn>
          <v-btn class="primary" @click="printPDF('admin|petition|petition|petition_create_permanent_council-make-full-zip' ,'make_full_zip','application/zip','document')"
                 v-if="allowed('admin|petition|petition|petition_create_permanent_council-make-full-zip' ,'make_full_zip')"  :loading=generatePdf.document>Сохранить ZIP архив документов</v-btn>
        </v-layout >

        <v-layout  justify-start row wrap >
          <v-card-text class="text-xs-left mr-3 ml-3"><h3 v-if="dataApp.status !== null">Статус заявки:
            {{dataApp.status.status.name}}</h3></v-card-text>
          <v-btn class="primary mr-3 ml-3" @click="opened_form_status = true">Изменить статус заявки</v-btn>
        </v-layout>
        <!--        <v-card-text class="text-xs-left mr-3 ml-3" v-if="dataApp.status.motivation"><h3>Причина изменения статуса: {{dataApp.status.motivation}}</h3></v-card-text>-->
      </v-layout>
      <v-card-text class="text-xs-left mr-3 ml-3"><h3>Подразделения:</h3>
        <v-sheet
          class="pa-1"
          color="grey lighten-3"
          v-for="(item, index) in dataApp.departments ">{{dataApp.departments[index].uid}}</v-sheet>
      </v-card-text>
      <v-card-text class="text-xs-left mr-3 ml-3"><h3>Специальности:</h3>
        <v-sheet
          class="pa-1"
          color="grey lighten-3"
          v-for="(item, index) in dataApp.specialities "  style="word-break: break-all;">  {{item.speciality}}-{{item.branch}} </v-sheet>
      </v-card-text>
      <v-card-text class="text-xs-left mr-3 ml-3"><h3>Ученый секретарь диссертационного совета :
        {{dataApp.scientific_secretary}}</h3></v-card-text>
      <v-card-text class="text-xs-left mr-3 ml-3"><h3>Председатель диссертационного совета : {{dataApp.chairman}}</h3>
      </v-card-text>

      <v-card-text class="text-xs-left mr-3 ml-3">
        <h3>Заместитель председателя:</h3> <h3 v-for="(item, index) in dataApp.vice_chairmans" >
        <div v-if="item.worker !== null">{{item.worker}}</div>
        <div v-else>{{item.fio}}</div>
      </h3>
      </v-card-text>

      <v-layout class="pb-0 pt-2" justify-start row wrap>

      <v-card-text  class="text-xs-left mr-3 ml-3">
        <h3>
          Список кандидатов
        </h3>
      </v-card-text>

      </v-layout>

      <v-data-table
        :headers="headers"
        :items="items"
        :rows-per-page-items="[5,15,35,{text:'Все', value:-1}]"
        class="elevation-1  "
        no-data-text="Нет данных"
        rows-per-page-text="Число элементов"
      >
        <template slot="items" slot-scope="props">
          <td class="justify-center">{{props.item.fio}}</td>
          <td class="justify-center">{{props.item.birth}}</td>
          <td class="justify-center">{{props.item.citizenship}}</td>
          <td class="justify-center">{{props.item.academic_degree}}</td>
          <td class="justify-center">{{props.item.status}}</td>
          <td class="justify-center">{{props.item.speciality}}</td>
          <td class = justify-center>
            <v-icon  v-if="props.item.publications !== null"
                     @click="goToPathItem(props.item.publications)"
            >cloud_download</v-icon>
            <v-icon  v-else >close</v-icon>
          </td>
        </template>
        <template slot="pageText" slot-scope="item">
          {{item.pageStart}} - {{item.pageStop}} из {{item.itemsLength}}
        </template>
        <template slot="no-data">
          <v-btn @click="getItems()" color="primary">Обновить</v-btn>
        </template>
      </v-data-table>

      <v-card-text class="text-xs-left mr-3 ml-3">
        <h3>Создатель заявки:{{dataApp.creator}}</h3>
      </v-card-text>
    </v-card>
    <v-dialog persistent v-model="opened_form_status" width="600">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>Смена статуса</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-toolbar-items>
              <v-btn @click="opened_form_status = false" class="pa-0 ma-0" dark flat icon>
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar-items>
        </v-toolbar>
        <ChangeStatus v-if="dataApp.status !== null"
          v-bind:id="dataApp.status.status.id" typeSt="council"

          @ended="closedForm"
        >
        </ChangeStatus>
        <v-card-text v-else> Начальный статус не установлен</v-card-text>
      </v-card>
    </v-dialog>
  </v-container>

</template>

<script>
    import urlsW from "../urlsW.js"
    import UserDataFormMixin from '../../../mixins/UserDataFormMixin'
    import urls from "../urls.js"
    import {makeGetRequest, makeManagerUrl} from "../../../helper";
    import ChangeStatus from "../forms/ChangeStatus.vue"

    export default {
        name: "DetailCouncil",
        mixins: [UserDataFormMixin],

        components: {
            ChangeStatus,
        },
        data: function () {
            return {
                items: [],
                generatePdf: {
                    document:false,
                    council:false,
                    personals:false,
                    candidate:false,
                    department:false,
                },
                show_loadind: false,
                headers: [
                    {
                        text: 'ФИО',
                        align: 'justify-center',
                        sortable: true,
                        value: 'fio',
                    },
                    {
                        text: 'Дата рождения',
                        align: 'justify-center',
                    },
                    {
                        text: 'Страна',
                        align: 'justify-center',
                    },
                    {
                        text: 'Ученая степень',
                        align: 'justify-center',
                    },
                    {
                        text: 'Статус в совете',
                        align: 'justify-center',
                    },
                    {
                        text: 'Шифр науч спец,представляемой в совете',
                        align: 'justify-center',
                    },
                    {
                        text: 'Файл публикаций',
                        align: 'justify-center',
                    },
                ],
                opened_form_status: false,
                dataApp: {
                    "status": {"status": "null"},
                    "responsible": null,
                    "departments": null,
                },
                selectors: {
                    department: [],
                },
            }

        },
        methods: {
            getItems: function () {
                let url = urls.getUrl('admin|petition|petition|petition_create_permanent_council|candidate-list', 'list').replace('<petition>', this.dataApp.id)
                makeGetRequest(url)
                    .then(resp => {
                        return resp.json()
                    }).then(json => {
                    let list = json;
                    this.items = list;
                });
            },
            goToPathItem(path){
                window.location=path;
            },

            download(content, fileName, contentType) {
                var a = document.createElement("a");
                a.href = URL.createObjectURL(content);
                a.download = fileName;
                a.click();
            },

            allowed(urlname, action) {
                return urls.getUrlAllowed(urlname, action)
            },

            printPDF(typed,action,type,nameFile) {
                this.generatePdf[nameFile] = true;
                let status = true;
                let name = nameFile + '.pdf';
                if (type === "application/zip")
                     name = nameFile + '.zip';
                if (type === "application/csv")
                    name = nameFile + '.csv';
                makeGetRequest(
                    urls.getUrl(typed, action).replace('<petition>', this.dataApp.id).replace('<id>', this.dataApp.id),
                ).then(resp => {
                    if (!resp.ok) {
                        status = false;
                    }
                    console.log(resp)
                    return resp.blob();
                }).then(blob => {
                    this.download(blob, name, type);
                    this.generatePdf[nameFile] = false;
                })

            },

            closedForm: function () {
                this.opened_form_status = false
                this.alert = true
                this.getData();
            },

            setDepartment() {
                for (var key in this.dataApp.departments) {
                    var dep = this.selectors.department.find(department => department.value === this.dataApp.departments[key].uid);
                    this.dataApp.departments[key].uid = dep.text
                }
            },

            setTitleWorker(item,key) {
                makeGetRequest(urlsW.getUrl('profile_worker-title', 'title').replace('<user>', item)).then(
                    resp => resp.json())
                    .then(json => {
                        this.dataApp[key] = json.title
                    })
            },

            setTitleCharman() {
                for (var key in this.dataApp.vice_chairmans){
                    if(this.dataApp.vice_chairmans[key].worker!== null ){
                        let a = key
                        makeGetRequest(urlsW.getUrl('profile_worker-title', 'title').replace('<user>', this.dataApp.vice_chairmans[a].worker)).then(
                            resp => resp.json())
                            .then(json => {
                                this.dataApp.vice_chairmans[a].worker= json.title
                            })
                    }
                }
            },

            getData() {
                makeGetRequest(
                    makeManagerUrl(urls.getUrl('admin|petition|petition|petition_create_permanent_council-detail', 'retrieve')).replace('<id>', this.$route.params.id),
                ).then(resp => resp.json())
                    .then(json => {
                        this.dataApp = json
                        this.setTitleWorker(this.dataApp.scientific_secretary, "scientific_secretary")
                        this.setTitleWorker(this.dataApp.chairman, "chairman")
                        this.setTitleWorker(this.dataApp.creator, "creator")
                        this.getItems()
                        this.setDepartment()
                        this.setTitleCharman()
                    })
            }

        },
        created() {

            this.$store.commit('mainpage/changeTitle', 'Дисс совет');

            this.getChoices(
                urlsW.getUrl('selectors|department-uid', 'get').replace('<organization_id>', '1'),
            ).then(choices => {
                this.selectors.department = choices
                this.getData();
            });

        },

    }
</script>

<style scoped>

</style>
